import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  
import Dashboard from './Components/Dashboard';
import Products from './Components/Products';
import Orders from './Components/Orders'; 
import Customers from './Components/Customers';
import Revenue from './Components/Revenue';
import OrdersCalendar from './Components/OrdersCalendar'; // all essential components
import './App.css';

const App = () => {
  return (
    <Router>
      <Routes>  { /*we can go with switches also */ }
        <Route exact path="/" element={<Dashboard />} /> {/* my landing page */}
        <Route path="/products" element={<Products />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/revenue" element={<Revenue />} />
        <Route path="/calendar" element={<OrdersCalendar/>}/>
      </Routes>
    </Router>
  );
};

export default App;
